import { SESSION_URL } from '../constants';

export async function fetchSession() {
  const response = await fetch(
    `${process.env.NEXT_PUBLIC_ZAPIER_ORIGIN}${SESSION_URL}`,
    {
      credentials: 'include',
    }
  );
  const session = await response.json();
  return session;
}
